import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createUseStyles } from "react-jss";
import FilterListIcon from "@mui/icons-material/FilterList";
import { InputAdornment } from "@mui/material";
import { theme } from "$utils/theme/bataillog";
import { Autocomplete } from "$components/Forms/AutoComplete";
import { getCompanies } from "$services/Company.service";

import { appState } from "$store";
import { setFilter } from "$actions/app";
import { CompanyType } from "$types";
import { CacheInvalidationAction } from "$utils/cache";

function InputFilter() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleSelecteValue = useCallback(
    (data: any) => {
      dispatch(setFilter(data));
    },
    [dispatch]
  );

  const { filter } = useSelector(appState);

  return (
    <div className={classes.wrapper}>
      <Autocomplete
        withControl={false}
        noOptionsText="Pas de résultat"
        value={filter?.name ?? ""}
        classes={{ inputRoot: classes.autocompleteText }}
        className={classes.select}
        placeholder={filter ? filter.name : "Filtrer entreprise"}
        queryFunction={getCompanies}
        queryFunctionName={CacheInvalidationAction.GET_COMPANIES}
        lookingFor="name"
        withInit
        filters={{ isActive: true, companyTypes: CompanyType.CLIENT }}
        inputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FilterListIcon style={{ color: "white" }} />
            </InputAdornment>
          ),
        }}
        cacheTime={10 * 60 * 1000}
        onChange={(newValue: any) => {
          handleSelecteValue(newValue);
        }}
      />
      {/* <Autocomplete
        noOptionsText="Pas de résultat"
        value={currentValue}
        classes={{ inputRoot: classes.autocompleteText }}
        options={companiesOptions || []}
        getOptionLabel={(option: any) => option?.name || option}
        onChange={(_event: any, newValue: any) => {
          handleSelecteValue(newValue);
        }}
        className={classes.select}
        renderInput={(params: any) => (
          <TextField
            {...params}
            className={`${classes.autocompleteText} ${
              filter ? classes.placeholderWhite : ""
            }`}
            placeholder={filter ? filter.name : "Filtrer entreprise"}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <FilterListIcon />
                </InputAdornment>
              ),
            }}
            variant="outlined"
            size="small"
          />
        )}
      /> */}
    </div>
  );
}

const useStyles = createUseStyles(() => ({
  wrapper: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  autocompleteText: {
    color: "#FFFFFF !important",
    "& .MuiIconButton-root": {
      color: "white",
    },
  },
  placeholderWhite: {
    "& input::placeholder": {
      color: "white",
      opacity: 1,
    },
  },
  select: {
    marginTop: 5,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#FFFFFF",
      borderWidth: 1,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#FFFFFF !important",
      borderWidth: 1,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#FFFFFF !important",
      borderWidth: 1,
    },
  },
}));

export default InputFilter;
